import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-delete-account',
    standalone: true,
    imports: [
        CommonModule, 
        FormsModule, 
        ReactiveFormsModule,
        InputTextModule,
        InputTextareaModule,
        CheckboxModule,
        ButtonModule
    ],
    templateUrl: './delete-account.component.html',
    styleUrls: ['./delete-account.component.scss']
})
export class DeleteAccountComponent {
    deleteForm: FormGroup;
    isSubmitted = false;
    isSending = false;

    constructor(private fb: FormBuilder) {
        this.deleteForm = this.fb.group({
            fullName: ['', [Validators.required, Validators.minLength(3)]],
            email: ['', [Validators.required, Validators.email]],
            reason: [''],
            confirmCheckbox: [false, [Validators.requiredTrue]]
        });
    }

    onSubmit() {
        if (this.deleteForm.invalid) {
            this.markAllAsTouched();
            return;
        }

        this.isSending = true;

        // Simular envío de solicitud
        setTimeout(() => {
            this.isSending = false;
            this.isSubmitted = true;
            this.deleteForm.reset();
        }, 1500);
    }

    private markAllAsTouched() {
        Object.keys(this.deleteForm.controls).forEach(key => {
            const control = this.deleteForm.get(key);
            control?.markAsTouched();
        });
    }
}
